import {
  GraphQLEnv,
  brand,
  env,
  getConfigValue,
  graphqlEnv,
  graphqlGatewayEnv,
  region,
} from 'utils/environment';

export enum QUERY_TYPE {
  LambdaGraphqlQuery,
  SanityGroqQuery,
  SanityGraphqlQuery,
  GatewayGraphqlQuery,
}

export const getGraphqlGatewayApiUrl = () => {
  const awsConfig = getConfigValue({ key: 'aws', defaultValue: {} });
  switch (graphqlGatewayEnv()) {
    case GraphQLEnv.TEST:
      return 'https://use1-dev-bk-gateway.rbictg.com/graphql';
    case GraphQLEnv.LOCAL:
      return 'http://localhost:3002/graphql';
    default:
      return (
        awsConfig.gqlGatewayApiUrl ||
        `https://use1-${graphqlEnv()}-${brand()}-gateway.rbictg.com/graphql`
      );
  }
};

const MENU_CDN_ORIGIN = `https://use1-${env().toLowerCase()}-bk-menu.rbictg.com`;

export const MENU_API_URL = `${MENU_CDN_ORIGIN}/store`;
export const DEFAULT_MENU_VARIANT_KEY = 'menu';

/** CloudFront artifact for the store-less menu: `/generic-{region}-app-{variant}.json`. */
export const genericMenuArtifactUrl = (variantKey: string) =>
  `${MENU_CDN_ORIGIN}/generic-${region.toLowerCase()}-app-${variantKey}.json`;

export enum HttpErrorCodes {
  BadRequest = 400,
  InternalServerError = 500,
  TooManyRequests = 429,
  Unauthorized = 401,
  Conflict = 409,
}
